<template>
  <div class="home">
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <div ref="mainOverlay" class="main-overlay">
      <div ref="preloader">
        <LoaderHome />
      </div>
    </div>
    <Header v-if="!login" @goto="handleScrollTo" />
    <HeaderDefaultRegistered v-else @goto="handleScrollTo" />
    <transition v-if="isPressPageOpen" name="fade" mode="out-in">
      <router-view />
    </transition>
    <transition v-else name="fade" mode="out-in">
      <div class="main">
        <section class="section hero-section">
          <div class="container-small hero-wrapper">
            <h1 class="hero-title">
              Automated Remote<br> Mobile Data Collection
            </h1>
            <p class="hero-descr">
              PME provides secure, cost-effective access to critical data sets<br>
              found on mobile devices through targeted remote collection.
            </p>
            <div class="hero-btn-wrap">
              <button class="hero-btn btn" @click="scrollToContactForm()">
                Contact Sales
              </button>
            </div>
          </div>
        </section>
        <section class="section section-how-work">
          <div class="container-small">
            <div class="explore" @click="scrollToBenefits()">
              <p>Explore more</p>
              <svg
                width="20"
                height="26"
                viewBox="0 0 20 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 15.1362L2.68311 7.81934L3.56934 6.93311L10 13.3638L16.4307 6.93311L17.3169 7.81934L10 15.1362Z"
                  fill="white"
                />
                <path
                  d="M10 22.1816L0.244141 12.4258L1.42578 11.2441L10 19.8184L18.5742 11.2441L19.7559 12.4258L10 22.1816Z"
                  fill="white"
                />
              </svg>
            </div>
            <h2 class="title">
              Automated Remote Discovery & Web-<br>Based Review Platform
            </h2>
            <p class="descr">
              Speed time to discovery while reducing costs by leveraging PME for user-driven remote collection of mobile
              data combined with a SaaS-based review platform, all stored securely in the cloud, available on-demand to
              users worldwide.
            </p>
          </div>
        </section>

        <section id="PME Features" ref="benefits" class="section section-benefit">
          <div class="container-small">
            <h2 class="title">
              PME Features and Benefits
            </h2>
            <div class="benefit-img-section">
              <div class="benefit-item-container">
                <div class="benefit-item">
                  <div class="benefit-logo">
                    <svg
                      width="60"
                      height="60"
                      viewBox="0 0 60 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M54.375 28.125H52.4203C51.9704 22.8268 49.6613 17.8584 45.9014 14.0986C42.1416 10.3387 37.1732 8.02962 31.875 7.57969V5.625C31.875 5.12772 31.6775 4.65081 31.3258 4.29917C30.9742 3.94754 30.4973 3.75 30 3.75C29.5027 3.75 29.0258 3.94754 28.6742 4.29917C28.3225 4.65081 28.125 5.12772 28.125 5.625V7.57969C22.8268 8.02962 17.8584 10.3387 14.0986 14.0986C10.3387 17.8584 8.02962 22.8268 7.57969 28.125H5.625C5.12772 28.125 4.65081 28.3225 4.29917 28.6742C3.94754 29.0258 3.75 29.5027 3.75 30C3.75 30.4973 3.94754 30.9742 4.29917 31.3258C4.65081 31.6775 5.12772 31.875 5.625 31.875H7.57969C8.02962 37.1732 10.3387 42.1416 14.0986 45.9014C17.8584 49.6613 22.8268 51.9704 28.125 52.4203V54.375C28.125 54.8723 28.3225 55.3492 28.6742 55.7008C29.0258 56.0525 29.5027 56.25 30 56.25C30.4973 56.25 30.9742 56.0525 31.3258 55.7008C31.6775 55.3492 31.875 54.8723 31.875 54.375V52.4203C37.1732 51.9704 42.1416 49.6613 45.9014 45.9014C49.6613 42.1416 51.9704 37.1732 52.4203 31.875H54.375C54.8723 31.875 55.3492 31.6775 55.7008 31.3258C56.0525 30.9742 56.25 30.4973 56.25 30C56.25 29.5027 56.0525 29.0258 55.7008 28.6742C55.3492 28.3225 54.8723 28.125 54.375 28.125ZM31.875 48.6562V46.875C31.875 46.3777 31.6775 45.9008 31.3258 45.5492C30.9742 45.1975 30.4973 45 30 45C29.5027 45 29.0258 45.1975 28.6742 45.5492C28.3225 45.9008 28.125 46.3777 28.125 46.875V48.6562C23.8239 48.2174 19.8059 46.3083 16.7488 43.2512C13.6916 40.1941 11.7826 36.1761 11.3438 31.875H13.125C13.6223 31.875 14.0992 31.6775 14.4508 31.3258C14.8025 30.9742 15 30.4973 15 30C15 29.5027 14.8025 29.0258 14.4508 28.6742C14.0992 28.3225 13.6223 28.125 13.125 28.125H11.3438C11.7826 23.8239 13.6916 19.8059 16.7488 16.7488C19.8059 13.6916 23.8239 11.7826 28.125 11.3438V13.125C28.125 13.6223 28.3225 14.0992 28.6742 14.4508C29.0258 14.8025 29.5027 15 30 15C30.4973 15 30.9742 14.8025 31.3258 14.4508C31.6775 14.0992 31.875 13.6223 31.875 13.125V11.3438C36.1761 11.7826 40.1941 13.6916 43.2512 16.7488C46.3083 19.8059 48.2174 23.8239 48.6562 28.125H46.875C46.3777 28.125 45.9008 28.3225 45.5492 28.6742C45.1975 29.0258 45 29.5027 45 30C45 30.4973 45.1975 30.9742 45.5492 31.3258C45.9008 31.6775 46.3777 31.875 46.875 31.875H48.6562C48.2174 36.1761 46.3083 40.1941 43.2512 43.2512C40.1941 46.3083 36.1761 48.2174 31.875 48.6562ZM30 20.625C28.1458 20.625 26.3332 21.1748 24.7915 22.205C23.2498 23.2351 22.0482 24.6993 21.3386 26.4123C20.6291 28.1254 20.4434 30.0104 20.8051 31.829C21.1669 33.6475 22.0598 35.318 23.3709 36.6291C24.682 37.9402 26.3525 38.8331 28.171 39.1949C29.9896 39.5566 31.8746 39.3709 33.5877 38.6614C35.3007 37.9518 36.7649 36.7502 37.795 35.2085C38.8252 33.6668 39.375 31.8542 39.375 30C39.375 27.5136 38.3873 25.129 36.6291 23.3709C34.871 21.6127 32.4864 20.625 30 20.625ZM30 35.625C28.8875 35.625 27.7999 35.2951 26.8749 34.677C25.9499 34.0589 25.2289 33.1804 24.8032 32.1526C24.3774 31.1248 24.266 29.9938 24.4831 28.9026C24.7001 27.8115 25.2359 26.8092 26.0225 26.0225C26.8092 25.2359 27.8115 24.7001 28.9026 24.4831C29.9938 24.266 31.1248 24.3774 32.1526 24.8032C33.1804 25.2289 34.0589 25.9499 34.677 26.8749C35.2951 27.7999 35.625 28.8875 35.625 30C35.625 31.4918 35.0324 32.9226 33.9775 33.9775C32.9226 35.0324 31.4918 35.625 30 35.625Z"
                        fill="#8692A6"
                      />
                    </svg>
                  </div>
                  <h3 class="benefit-item-title">
                    Targeted Remote Collection
                  </h3>
                  <p class="benefit-item-text">
                    No more shipping collection kits, dispatching techs, or taking devices away from custodians. Reduce
                    costs and time to discovery by leveraging PME's SaaS-based platform to perform user-led targeted
                    remote collection. Custodians are guided through the process of collecting data from the relevant
                    sources while preserving the privacy of out-of-scope data.
                  </p>
                </div>
              </div>
              <div class="benefit-item-container">
                <div class="benefit-item">
                  <div class="benefit-logo">
                    <svg
                      width="60"
                      height="60"
                      viewBox="0 0 60 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M48.75 31.875H11.25C10.2554 31.875 9.30161 32.2701 8.59835 32.9734C7.89509 33.6766 7.5 34.6304 7.5 35.625V46.875C7.5 47.8696 7.89509 48.8234 8.59835 49.5266C9.30161 50.2299 10.2554 50.625 11.25 50.625H48.75C49.7446 50.625 50.6984 50.2299 51.4016 49.5266C52.1049 48.8234 52.5 47.8696 52.5 46.875V35.625C52.5 34.6304 52.1049 33.6766 51.4016 32.9734C50.6984 32.2701 49.7446 31.875 48.75 31.875ZM48.75 46.875H11.25V35.625H48.75V46.875ZM48.75 9.375H11.25C10.2554 9.375 9.30161 9.77009 8.59835 10.4733C7.89509 11.1766 7.5 12.1304 7.5 13.125V24.375C7.5 25.3696 7.89509 26.3234 8.59835 27.0266C9.30161 27.7299 10.2554 28.125 11.25 28.125H48.75C49.7446 28.125 50.6984 27.7299 51.4016 27.0266C52.1049 26.3234 52.5 25.3696 52.5 24.375V13.125C52.5 12.1304 52.1049 11.1766 51.4016 10.4733C50.6984 9.77009 49.7446 9.375 48.75 9.375ZM48.75 24.375H11.25V13.125H48.75V24.375ZM45 18.75C45 19.3063 44.835 19.85 44.526 20.3125C44.217 20.7751 43.7777 21.1355 43.2638 21.3484C42.7499 21.5613 42.1844 21.617 41.6388 21.5085C41.0932 21.3999 40.5921 21.1321 40.1988 20.7387C39.8054 20.3454 39.5376 19.8443 39.429 19.2987C39.3205 18.7531 39.3762 18.1876 39.5891 17.6737C39.802 17.1598 40.1624 16.7205 40.625 16.4115C41.0875 16.1024 41.6312 15.9375 42.1875 15.9375C42.9334 15.9375 43.6488 16.2338 44.1762 16.7613C44.7037 17.2887 45 18.0041 45 18.75ZM45 41.25C45 41.8063 44.835 42.35 44.526 42.8125C44.217 43.2751 43.7777 43.6355 43.2638 43.8484C42.7499 44.0613 42.1844 44.117 41.6388 44.0085C41.0932 43.8999 40.5921 43.6321 40.1988 43.2387C39.8054 42.8454 39.5376 42.3443 39.429 41.7987C39.3205 41.2531 39.3762 40.6876 39.5891 40.1737C39.802 39.6598 40.1624 39.2205 40.625 38.9115C41.0875 38.6025 41.6312 38.4375 42.1875 38.4375C42.9334 38.4375 43.6488 38.7338 44.1762 39.2613C44.7037 39.7887 45 40.5041 45 41.25Z"
                        fill="#8692A6"
                      />
                    </svg>
                  </div>
                  <h3 class="benefit-item-title">
                    Regional Data Storage
                  </h3>
                  <p class="benefit-item-text">
                    Maintain compliance and privacy with per-case data localization. Store your case data in multiple
                    geographic regions while managing and accessing it all through a single site. Currently supporting
                    data storage locations in the US, EU, and Asia.
                  </p>
                </div>
              </div>
              <div class="benefit-item-container">
                <div class="benefit-item">
                  <div class="benefit-logo">
                    <svg
                      width="61"
                      height="60"
                      viewBox="0 0 61 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M50.5766 19.2984L37.4516 6.17344C37.2773 5.99937 37.0705 5.86135 36.8428 5.76724C36.6152 5.67314 36.3713 5.62481 36.125 5.625H13.625C12.6304 5.625 11.6766 6.02009 10.9733 6.72335C10.2701 7.42661 9.875 8.38044 9.875 9.375V50.625C9.875 51.6196 10.2701 52.5734 10.9733 53.2766C11.6766 53.9799 12.6304 54.375 13.625 54.375H47.375C48.3696 54.375 49.3234 53.9799 50.0266 53.2766C50.7299 52.5734 51.125 51.6196 51.125 50.625V20.625C51.1252 20.3787 51.0769 20.1348 50.9828 19.9072C50.8887 19.6795 50.7506 19.4727 50.5766 19.2984ZM38 12.0258L44.7242 18.75H38V12.0258ZM47.375 50.625H13.625V9.375H34.25V20.625C34.25 21.1223 34.4475 21.5992 34.7992 21.9508C35.1508 22.3025 35.6277 22.5 36.125 22.5H47.375V50.625ZM36.7016 39.1758C37.8081 37.4174 38.2281 35.313 37.8811 33.2646C37.5342 31.2162 36.4447 29.3674 34.8208 28.0715C33.197 26.7756 31.1526 26.1234 29.0783 26.2395C27.0039 26.3557 25.0451 27.232 23.576 28.701C22.107 30.1701 21.2307 32.1289 21.1145 34.2033C20.9984 36.2776 21.6506 38.322 22.9465 39.9458C24.2424 41.5697 26.0912 42.6592 28.1396 43.0061C30.188 43.3531 32.2924 42.9331 34.0508 41.8266L36.6734 44.4516C36.8476 44.6258 37.0545 44.764 37.2821 44.8582C37.5097 44.9525 37.7536 45.001 38 45.001C38.2464 45.001 38.4903 44.9525 38.7179 44.8582C38.9455 44.764 39.1524 44.6258 39.3266 44.4516C39.5008 44.2774 39.639 44.0705 39.7332 43.8429C39.8275 43.6153 39.876 43.3714 39.876 43.125C39.876 42.8786 39.8275 42.6347 39.7332 42.4071C39.639 42.1795 39.5008 41.9726 39.3266 41.7984L36.7016 39.1758ZM24.875 34.6875C24.875 33.7604 25.1499 32.8541 25.665 32.0833C26.1801 31.3124 26.9121 30.7116 27.7687 30.3568C28.6252 30.002 29.5677 29.9092 30.477 30.0901C31.3863 30.2709 32.2215 30.7174 32.8771 31.3729C33.5326 32.0285 33.9791 32.8637 34.1599 33.773C34.3408 34.6823 34.248 35.6248 33.8932 36.4813C33.5384 37.3379 32.9376 38.0699 32.1667 38.585C31.3959 39.1001 30.4896 39.375 29.5625 39.375C28.3193 39.375 27.127 38.8811 26.2479 38.0021C25.3689 37.123 24.875 35.9307 24.875 34.6875Z"
                        fill="#8692A6"
                      />
                    </svg>
                  </div>
                  <h3 class="benefit-item-title">
                    Web-based Review Platform
                  </h3>
                  <p class="benefit-item-text">
                    Your team can review case data from anywhere using only a web browser- highlight, comment, redact,
                    tag, and export data in several convenient formats. View pictures, video, and documents, and listen
                    to embedded audio, in context with transcriptions and translations. Leverage powerful search tools
                    to surface relevant data while preserving its context.
                  </p>
                </div>
              </div>
              <div class="benefit-item-container">
                <div class="benefit-item">
                  <div class="benefit-logo">
                    <svg
                      width="61"
                      height="60"
                      viewBox="0 0 61 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_16058_17849)">
                        <path
                          d="M55.9867 16.2795L55.9849 16.2328C55.9588 15.6565 55.9414 15.0468 55.9309 14.3684C55.8819 11.0601 53.2521 8.32361 49.9434 8.13867C43.0449 7.75369 37.7083 5.50425 33.1485 1.05983L33.1096 1.02276C31.6223 -0.340919 29.3788 -0.340919 27.8911 1.02276L27.8522 1.05983C23.2924 5.50425 17.9558 7.75369 11.0574 8.13913C7.74912 8.32361 5.11881 11.0601 5.06983 14.3688C5.05976 15.0426 5.04191 15.6524 5.01582 16.2328L5.01307 16.3413C4.87895 23.3758 4.71232 32.1305 7.64108 40.0768C9.25149 44.4466 11.6905 48.2451 14.8898 51.3675C18.5335 54.9234 23.3062 57.7464 29.0749 59.7578C29.2626 59.8232 29.4576 59.8764 29.6563 59.9162C29.9364 59.972 30.2184 59.9999 30.5004 59.9999C30.7823 59.9999 31.0648 59.972 31.3445 59.9162C31.5431 59.8764 31.7395 59.8228 31.9281 59.7569C37.69 57.7418 42.4576 54.9174 46.0982 51.362C49.2961 48.2387 51.735 44.4392 53.3468 40.0685C56.2866 32.0984 56.1204 23.3272 55.9867 16.2795ZM50.0436 38.8504C46.9546 47.2256 40.649 52.9774 30.7663 56.4335C30.7311 56.4454 30.6935 56.456 30.6546 56.4637C30.5525 56.4839 30.4486 56.4839 30.3452 56.4633C30.3067 56.4555 30.2692 56.4454 30.2344 56.4335C20.3412 52.9838 14.0314 47.2352 10.9448 38.8596C8.24533 31.5349 8.39822 23.4984 8.53326 16.4086L8.53418 16.3692C8.56164 15.76 8.57996 15.1218 8.59003 14.4205C8.612 12.9516 9.78204 11.7362 11.2537 11.6543C15.1575 11.4364 18.5871 10.682 21.7383 9.34808C24.8855 8.01599 27.6805 6.13825 30.2825 3.60774C30.4148 3.49605 30.5864 3.49559 30.7183 3.60774C33.3206 6.13825 36.1157 8.01599 39.2624 9.34808C42.4136 10.682 45.8432 11.4364 49.7474 11.6543C51.2191 11.7362 52.3892 12.9516 52.4107 14.421C52.4212 15.126 52.4395 15.7641 52.467 16.3692C52.6016 23.4673 52.7508 31.5102 50.0436 38.8504Z"
                          fill="#8692A6"
                        />
                        <path
                          d="M30.4997 15.0479C22.2545 15.0479 15.5469 21.7559 15.5469 30.0007C15.5469 38.2459 22.2545 44.954 30.4997 44.954C38.7445 44.954 45.4526 38.2459 45.4526 30.0007C45.4526 21.7559 38.7445 15.0479 30.4997 15.0479ZM30.4997 41.4329C24.1959 41.4329 19.0675 36.3046 19.0675 30.0007C19.0675 23.6968 24.1959 18.5685 30.4997 18.5685C36.8031 18.5685 41.9315 23.6968 41.9315 30.0007C41.9315 36.3046 36.8031 41.4329 30.4997 41.4329Z"
                          fill="#8692A6"
                        />
                        <path
                          d="M34.7963 25.3588L27.8511 32.304L25.966 30.4189C25.2785 29.7313 24.1638 29.7313 23.4763 30.4189C22.7892 31.1065 22.7892 32.2211 23.4763 32.9082L26.6065 36.0384C26.9502 36.3822 27.4007 36.5539 27.8511 36.5539C28.3016 36.5539 28.752 36.3822 29.0958 36.0384L37.2861 27.8481C37.9732 27.1605 37.9732 26.0459 37.2861 25.3588C36.5985 24.6708 35.4839 24.6708 34.7963 25.3588Z"
                          fill="#8692A6"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_16058_17849">
                          <rect
                            width="60"
                            height="60"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h3 class="benefit-item-title">
                    Data Security & Privacy
                  </h3>
                  <p class="benefit-item-text">
                    The security and privacy of your data is our paramount concern. Custodian data is isolated on a
                    per-case basis, encrypted in transit and at rest, and access is controlled by you through our robust
                    access management controls.
                  </p>
                </div>
              </div>
              <div class="benefit-item-container">
                <div class="benefit-item">
                  <div class="benefit-logo">
                    <svg
                      width="61"
                      height="60"
                      viewBox="0 0 61 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_16058_17847)">
                        <path
                          d="M56.9844 23.7144V18.1641C56.9844 17.0494 56.5367 16.0373 55.8125 15.2975V6.44531C55.8125 2.89124 52.9213 0 49.3672 0H6.94531C3.39124 0 0.5 2.89124 0.5 6.44531V34.5703C0.5 38.1244 3.39124 41.0156 6.94531 41.0156H19.8579L18.686 44.5312H17.6094C14.7017 44.5312 12.3359 46.897 12.3359 49.8047V53.3203C12.3359 54.2912 13.1228 55.0781 14.0938 55.0781H28.0839C28.7436 56.4624 30.1562 57.4219 31.7891 57.4219H38.5292C39.1353 58.9311 40.6125 60 42.3359 60H56.3984C58.6602 60 60.5 58.1602 60.5 55.8984V27.7734C60.5 25.7108 58.9692 23.9996 56.9844 23.7144ZM31.2031 46.2891V18.1641C31.2031 17.8404 31.4654 17.5781 31.7891 17.5781H52.8828C53.2065 17.5781 53.4688 17.8404 53.4688 18.1641V23.6719H42.3359C40.0709 23.6719 38.2344 25.5084 38.2344 27.7734V46.875H31.2031V46.2891ZM41.75 27.7734C41.75 27.4503 42.0128 27.1875 42.3359 27.1875H56.3984C56.7216 27.1875 56.9844 27.4503 56.9844 27.7734V49.4531H41.75V27.7734ZM6.94531 3.51562H49.3672C50.9826 3.51562 52.2969 4.82986 52.2969 6.44531V14.0625H31.7891C29.5273 14.0625 27.6875 15.9023 27.6875 18.1641V30.4688H4.01562V6.44531C4.01562 4.82986 5.32986 3.51562 6.94531 3.51562ZM4.01562 34.5703V33.9844H27.6875V37.5H6.94531C5.32986 37.5 4.01562 36.1858 4.01562 34.5703ZM23.564 41.0156H27.6875V44.5312H22.3921L23.564 41.0156ZM15.8516 49.8047C15.8516 48.8356 16.6403 48.0469 17.6094 48.0469H27.6875V51.5625H15.8516V49.8047ZM31.2031 53.3203V50.3906H38.2344V53.9062H31.7891C31.4659 53.9062 31.2031 53.6435 31.2031 53.3203ZM56.3984 56.4844H42.3359C42.0128 56.4844 41.75 56.2216 41.75 55.8984V52.9688H56.9844V55.8984C56.9844 56.2216 56.7216 56.4844 56.3984 56.4844Z"
                          fill="#8692A6"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_16058_17847">
                          <rect
                            width="60"
                            height="60"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h3 class="benefit-item-title">
                    Data Sources & Devices
                  </h3>
                  <p class="benefit-item-text">
                    PME supports both iOS and Android based mobile devices and allows for collection from a growing list
                    of data sources including Call Logs, Contacts, SMS, iMessage, WhatsApp, WeChat, Line, and Viber.
                  </p>
                </div>
              </div>
              <div class="benefit-item-container">
                <div class="benefit-item">
                  <div class="benefit-logo">
                    <svg
                      width="61"
                      height="60"
                      viewBox="0 0 61 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.5 0C15.9611 0 4.13281 11.8283 4.13281 26.3672C4.13281 27.9784 4.13281 40.4423 4.13281 40.6641C4.13281 43.5718 6.49848 45.9375 9.40625 45.9375H11.4664C12.192 47.9834 14.1459 49.4531 16.4375 49.4531C19.3453 49.4531 21.7109 47.0875 21.7109 44.1797V29.8828C21.7109 26.975 19.3453 24.6094 16.4375 24.6094C14.1459 24.6094 12.192 26.0791 11.4664 28.125H9.40625C8.78996 28.125 8.19863 28.2322 7.64844 28.4273V26.3672C7.64844 13.7668 17.8996 3.51562 30.5 3.51562C43.1004 3.51562 53.3516 13.7668 53.3516 26.3672V28.4273C52.8014 28.2322 52.21 28.125 51.5938 28.125H49.5336C48.808 26.0791 46.8541 24.6094 44.5625 24.6094C41.6547 24.6094 39.2891 26.975 39.2891 29.8828V44.1797C39.2891 47.0875 41.6547 49.4531 44.5625 49.4531C45.0947 49.4531 45.6084 49.3732 46.0931 49.2259C45.4355 51.3894 43.4225 52.9688 41.0469 52.9688H35.4711C34.7455 50.9229 32.7916 49.4531 30.5 49.4531C27.5922 49.4531 25.2266 51.8188 25.2266 54.7266C25.2266 57.6343 27.5922 60 30.5 60C32.7916 60 34.7455 58.5302 35.4711 56.4844H41.0469C45.8932 56.4844 49.8359 52.5416 49.8359 47.6953V45.9375H51.5938C54.5015 45.9375 56.8672 43.5718 56.8672 40.6641C56.8672 40.4456 56.8672 27.9771 56.8672 26.3672C56.8672 11.8283 45.0389 0 30.5 0ZM14.6797 29.8828C14.6797 28.9136 15.4682 28.125 16.4375 28.125C17.4068 28.125 18.1953 28.9136 18.1953 29.8828V44.1797C18.1953 45.1489 17.4068 45.9375 16.4375 45.9375C15.4682 45.9375 14.6797 45.1489 14.6797 44.1797V29.8828ZM9.40625 31.6406H11.1641V42.4219H9.40625C8.43699 42.4219 7.64844 41.6333 7.64844 40.6641V33.3984C7.64844 32.4292 8.43699 31.6406 9.40625 31.6406ZM30.5 56.4844C29.5307 56.4844 28.7422 55.6958 28.7422 54.7266C28.7422 53.7573 29.5307 52.9688 30.5 52.9688C31.4693 52.9688 32.2578 53.7573 32.2578 54.7266C32.2578 55.6958 31.4693 56.4844 30.5 56.4844ZM46.3203 44.1797C46.3203 45.1489 45.5318 45.9375 44.5625 45.9375C43.5932 45.9375 42.8047 45.1489 42.8047 44.1797V29.8828C42.8047 28.9136 43.5932 28.125 44.5625 28.125C45.5318 28.125 46.3203 28.9136 46.3203 29.8828V44.1797ZM53.3516 40.6641C53.3516 41.6333 52.563 42.4219 51.5938 42.4219H49.8359V31.6406H51.5938C52.563 31.6406 53.3516 32.4292 53.3516 33.3984V40.6641Z"
                        fill="#8692A6"
                      />
                    </svg>
                  </div>
                  <h3 class="benefit-item-title">
                    Built-in Support Tools
                  </h3>
                  <p class="benefit-item-text">
                    We make supporting your data custodians easier by allowing you to see what they see while performing
                    a collection, right from our site. Guide your custodians through real-time application visibility
                    and validate the collection process by rewinding their session and visually playing back their
                    steps.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="Our Platform" ref="review" class="section section-review">
          <div class="container-small">
            <h2 class="title">
              PME Review - Web-Based Review & Analysis
            </h2>
            <div class="themes-wrapper">
              <div class="themes-menu">
                <div
                  v-for="(theme, index) in reviewThemes"
                  :key="index"
                  class="menu-item"
                  @click="onReviewThemeClick(index)"
                >
                  <div class="text" :class="{ active: activeReviewIndex === index }">
                    {{ theme.headerText }}
                  </div>
                </div>
              </div>

              <transition :name="transitionName" mode="out-in">
                <div v-if="activeReviewTheme" :key="activeReviewIndex" class="review-content-wrapper">
                  <div class="theme-img-wrapper">
                    <img :src="activeReviewTheme.img" alt="img">
                  </div>
                  <div class="theme-desc-wrapper">
                    {{ activeReviewTheme.mainText }}
                  </div>
                  <button
                    id="home_header_button"
                    class="contact-btn btn"
                    @click="scrollToContactForm()"
                  >
                    Contact Sales
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </section>

        <section class="section section-collect">
          <div class="container-small">
            <div class="section-img-wrapper">
              <img :src="pmeCollect" alt="img">
            </div>
            <div class="section-desc-wrapper">
              <h2 class="title">
                PME Collect - Automated Remote Discovery
              </h2>
              <div class="text-wrapper divider">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.2508 5.98129C15.0519 5.98129 14.8611 6.06031 14.7205 6.20096C14.5798 6.34161 14.5008 6.53238 14.5008 6.73129V16.9213L1.78082 4.20129C1.63865 4.06881 1.4506 3.99669 1.2563 4.00012C1.062 4.00355 0.876615 4.08226 0.739202 4.21967C0.601789 4.35708 0.523076 4.54247 0.519648 4.73677C0.51622 4.93107 0.588344 5.11912 0.720824 5.26129L13.4408 17.9813H3.25082C3.05191 17.9813 2.86115 18.0603 2.72049 18.201C2.57984 18.3416 2.50082 18.5324 2.50082 18.7313C2.50082 18.9302 2.57984 19.121 2.72049 19.2616C2.86115 19.4023 3.05191 19.4813 3.25082 19.4813H15.2508C15.4497 19.4813 15.6405 19.4023 15.7812 19.2616C15.9218 19.121 16.0008 18.9302 16.0008 18.7313V6.73129C16.0008 6.53238 15.9218 6.34161 15.7812 6.20096C15.6405 6.06031 15.4497 5.98129 15.2508 5.98129Z"
                    fill="#082655"
                  />
                </svg>
                <span>
                  Optional pre-filtering allows for targeted collection and upload of only the relevant data ensuring custodian privacy and saving you time and money during the review process.
                </span>
              </div>
              <div class="text-wrapper">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.2508 5.98129C15.0519 5.98129 14.8611 6.06031 14.7205 6.20096C14.5798 6.34161 14.5008 6.53238 14.5008 6.73129V16.9213L1.78082 4.20129C1.63865 4.06881 1.4506 3.99669 1.2563 4.00012C1.062 4.00355 0.876615 4.08226 0.739202 4.21967C0.601789 4.35708 0.523076 4.54247 0.519648 4.73677C0.51622 4.93107 0.588344 5.11912 0.720824 5.26129L13.4408 17.9813H3.25082C3.05191 17.9813 2.86115 18.0603 2.72049 18.201C2.57984 18.3416 2.50082 18.5324 2.50082 18.7313C2.50082 18.9302 2.57984 19.121 2.72049 19.2616C2.86115 19.4023 3.05191 19.4813 3.25082 19.4813H15.2508C15.4497 19.4813 15.6405 19.4023 15.7812 19.2616C15.9218 19.121 16.0008 18.9302 16.0008 18.7313V6.73129C16.0008 6.53238 15.9218 6.34161 15.7812 6.20096C15.6405 6.06031 15.4497 5.98129 15.2508 5.98129Z"
                    fill="#082655"
                  />
                </svg>
                <span>
                  Selected data is extracted, enriched with metadata, encrypted for privacy, and uploaded to our cloud-based platform immediately upon extraction enabling same-day review.
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </transition>

    <section id="Contact us" ref="contactSales" class="section section-demo">
      <div class="container-small">
        <div class="content-wrapper">
          <div class="schedule-demo">
            <h2 class="title">
              Ready to Schedule a Demo?
            </h2>
            <div class="text-wrapper">
              <svg
                width="16"
                height="20"
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2508 5.98129C15.0519 5.98129 14.8611 6.06031 14.7205 6.20096C14.5798 6.34161 14.5008 6.53238 14.5008 6.73129V16.9213L1.78082 4.20129C1.63865 4.06881 1.4506 3.99669 1.2563 4.00012C1.062 4.00355 0.876615 4.08226 0.739202 4.21967C0.601789 4.35708 0.523076 4.54247 0.519648 4.73677C0.51622 4.93107 0.588344 5.11912 0.720824 5.26129L13.4408 17.9813H3.25082C3.05191 17.9813 2.86115 18.0603 2.72049 18.201C2.57984 18.3416 2.50082 18.5324 2.50082 18.7313C2.50082 18.9302 2.57984 19.121 2.72049 19.2616C2.86115 19.4023 3.05191 19.4813 3.25082 19.4813H15.2508C15.4497 19.4813 15.6405 19.4023 15.7812 19.2616C15.9218 19.121 16.0008 18.9302 16.0008 18.7313V6.73129C16.0008 6.53238 15.9218 6.34161 15.7812 6.20096C15.6405 6.06031 15.4497 5.98129 15.2508 5.98129Z"
                  fill="#082655"
                />
              </svg>
              <span>Schedule the best time for you in the calendar</span>
            </div>
            <div class="text-wrapper">
              <svg
                width="16"
                height="20"
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2508 5.98129C15.0519 5.98129 14.8611 6.06031 14.7205 6.20096C14.5798 6.34161 14.5008 6.53238 14.5008 6.73129V16.9213L1.78082 4.20129C1.63865 4.06881 1.4506 3.99669 1.2563 4.00012C1.062 4.00355 0.876615 4.08226 0.739202 4.21967C0.601789 4.35708 0.523076 4.54247 0.519648 4.73677C0.51622 4.93107 0.588344 5.11912 0.720824 5.26129L13.4408 17.9813H3.25082C3.05191 17.9813 2.86115 18.0603 2.72049 18.201C2.57984 18.3416 2.50082 18.5324 2.50082 18.7313C2.50082 18.9302 2.57984 19.121 2.72049 19.2616C2.86115 19.4023 3.05191 19.4813 3.25082 19.4813H15.2508C15.4497 19.4813 15.6405 19.4023 15.7812 19.2616C15.9218 19.121 16.0008 18.9302 16.0008 18.7313V6.73129C16.0008 6.53238 15.9218 6.34161 15.7812 6.20096C15.6405 6.06031 15.4497 5.98129 15.2508 5.98129Z"
                  fill="#082655"
                />
              </svg>
              <span>Meet with our Sales team</span>
            </div>
            <div class="text-wrapper">
              <svg
                width="16"
                height="20"
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2508 5.98129C15.0519 5.98129 14.8611 6.06031 14.7205 6.20096C14.5798 6.34161 14.5008 6.53238 14.5008 6.73129V16.9213L1.78082 4.20129C1.63865 4.06881 1.4506 3.99669 1.2563 4.00012C1.062 4.00355 0.876615 4.08226 0.739202 4.21967C0.601789 4.35708 0.523076 4.54247 0.519648 4.73677C0.51622 4.93107 0.588344 5.11912 0.720824 5.26129L13.4408 17.9813H3.25082C3.05191 17.9813 2.86115 18.0603 2.72049 18.201C2.57984 18.3416 2.50082 18.5324 2.50082 18.7313C2.50082 18.9302 2.57984 19.121 2.72049 19.2616C2.86115 19.4023 3.05191 19.4813 3.25082 19.4813H15.2508C15.4497 19.4813 15.6405 19.4023 15.7812 19.2616C15.9218 19.121 16.0008 18.9302 16.0008 18.7313V6.73129C16.0008 6.53238 15.9218 6.34161 15.7812 6.20096C15.6405 6.06031 15.4497 5.98129 15.2508 5.98129Z"
                  fill="#082655"
                />
              </svg>
              <span>Get a demo and discuss any questions you may have with the team</span>
            </div>
            <button class="hero-btn btn" @click.prevent="openCalendly">
              Schedule Demo
            </button>
          </div>
          <div class="contact-sales">
            <div class="form-wrapper">
              <h2 class="title">
                Write our Sales
              </h2>
              <div class="text-wrapper">
                <span>Interested in learning more?<br>Please use the form below to contact us for all inquiries.</span>
              </div>
              <form @submit.prevent="submit">
                <div class="form-group" :class="{ 'form-group--error': $v.formData.firstName.$error }">
                  <input
                    id="support_account_nick-name_input"
                    v-model="$v.formData.firstName.$model"
                    type="text"
                    placeholder="First name*"
                    class="input"
                    :class="false ? 'is-invalid' : ''"
                    autocomplete="off"
                    :maxlength="userFirstNameMax"
                  >
                  <div v-if="!$v.formData.firstName.required" class="error">
                    Field is required
                  </div>
                  <div v-if="!$v.formData.firstName.minLength" class="error">
                    Name must have at least
                    {{ $v.formData.firstName.$params.minLength.min }} letters.
                  </div>
                </div>
                <div class="form-group" :class="{ 'form-group--error': $v.formData.lastName.$error }">
                  <input
                    id="support_account_nick-name_input"
                    v-model="$v.formData.lastName.$model"
                    type="text"
                    placeholder="Last name*"
                    class="input"
                    :class="false ? 'is-invalid' : ''"
                    autocomplete="off"
                    :maxlength="userLastNameMax"
                  >
                  <div v-if="!$v.formData.lastName.required" class="error">
                    Field is required
                  </div>
                  <div v-if="!$v.formData.lastName.minLength" class="error">
                    Name must have at least
                    {{ $v.formData.lastName.$params.minLength.min }} letters.
                  </div>
                </div>
                <div class="form-group" :class="{ 'form-group--error': $v.formData.email.$error }">
                  <input
                    id="support_account_mail_input"
                    v-model="$v.formData.email.$model"
                    type="text"
                    placeholder="Email*"
                    class="input"
                    :class="false ? 'is-invalid' : ''"
                    autocomplete="off"
                  >
                  <div v-if="!$v.formData.email.required" class="error">
                    Field is required
                  </div>
                  <div v-if="!$v.formData.email.email" class="error">
                    This must be an email
                  </div>
                </div>
                <div class="form-group description">
                  <textarea
                    id="support_description"
                    v-model="formData.message"
                    name="description"
                    class="support-textarea"
                    placeholder="Message"
                  />
                </div>
                <div class="group">
                  <button id="support_account_button" class="hero-btn btn">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
    <CommonDialog
      ref="commonDialogFormSuccess"
      :title="'Order'"
    >
      <svg
        width="94"
        height="94"
        viewBox="0 0 94 94"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M47.0015 0.776367C37.8596 0.776367 28.9231 3.48725 21.3218 8.56622C13.7206 13.6452 7.79623 20.8641 4.29777 29.3101C0.799324 37.7561 -0.11603 47.0499 1.66746 56.0161C3.45096 64.9823 7.8532 73.2183 14.3175 79.6826C20.7818 86.1469 29.0178 90.5492 37.984 92.3327C46.9503 94.1162 56.244 93.2008 64.69 89.7024C73.136 86.2039 80.355 80.2795 85.4339 72.6783C90.5129 65.0771 93.2238 56.1405 93.2238 46.9986C93.2238 34.7397 88.3539 22.9829 79.6856 14.3145C71.0172 5.6462 59.2604 0.776367 47.0015 0.776367V0.776367ZM77.1904 31.4853L39.2304 69.4164L16.8127 46.9986C16.0465 46.2324 15.616 45.1932 15.616 44.1097C15.616 43.0262 16.0465 41.987 16.8127 41.2208C17.5788 40.4546 18.618 40.0242 19.7015 40.0242C20.7851 40.0242 21.8242 40.4546 22.5904 41.2208L39.2882 57.9186L71.4704 25.7653C71.8498 25.3859 72.3002 25.0849 72.7959 24.8796C73.2915 24.6743 73.8228 24.5686 74.3593 24.5686C74.8958 24.5686 75.4271 24.6743 75.9228 24.8796C76.4184 25.0849 76.8688 25.3859 77.2482 25.7653C77.6276 26.1446 77.9285 26.595 78.1338 27.0907C78.3392 27.5864 78.4448 28.1176 78.4448 28.6541C78.4448 29.1907 78.3392 29.7219 78.1338 30.2176C77.9285 30.7133 77.6276 31.1637 77.2482 31.543L77.1904 31.4853Z"
          fill="#082655"
        />
      </svg>
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <p class="dialog-message-description">
        Your request has been sent.<br>Our sales will contact you soon.
      </p>
    </CommonDialog>
  </div>
</template>

<script>
import targetedRemoteCollection from '@/assets/img/home/targeted-remote-collection.png';
import regionalDataStorage from '@/assets/img/home/regional-data-storage.png';
import webBasedReviewPlatform from '@/assets/img/home/web-based-review-platform.png';
import dataSecurity from '@/assets/img/home/data-security-privacy.png';
import dataSources from '@/assets/img/home/data-sources-devices.png';
import builtInSupport from '@/assets/img/home/built-in-support-tools.png';
import secureScalable from '@/assets/img/home/secure-scalable.png';
import webBasedPlatf from '@/assets/img/home/web-based-platf.png';
import searchTools from '@/assets/img/home/search-tools.png';
import dataReview from '@/assets/img/home/data-review.png';
import thirdPI from '@/assets/img/home/3-party-integration.png';
import pmeCollect from '@/assets/img/home/pme-collect.png';
import hasPermission from '../utils/permission';
import login from '../mixins/login';
import Header from '../components/layout/Header';
import HeaderDefaultRegistered from '../components/layout/HeaderDefaultRegistered';
import Footer from '@/components/Footer.vue';
import Velocity from 'velocity-animate';
import LoaderHome from '../components/loader/LoaderHome';
import {email, minLength, required} from 'vuelidate/lib/validators';
import CommonDialog from '@/components/popups/CommonDialog.vue';
import AlertErrorMsg from '@/components/profile/AlertErrorMsg.vue';
import debounce from '@/mixins/debounce';
import errorHandler from '@/mixins/errorHandler';

export default {
  name: 'Home',
  components: {
    AlertErrorMsg,
    CommonDialog,
    LoaderHome,
    Header,
    HeaderDefaultRegistered,
    Footer,
  },
  props: {
    duration: {
      default: false
    }
  },
  data() {
    return {
      pmeCollect,
      isPressPageOpen: false,
      userFirstNameMax: 50,
      userLastNameMax: 50,
      transitionName: 'slide-left',
      activeReviewIndex: 0,
      activeChooseIndex: 0,
      activeChooseImg: targetedRemoteCollection,
      googlePlay: '',
      appleStore: '',
      errorMessage: '',
      formData: {
        firstName: null,
        lastName: null,
        email: null,
        message: null,
      },
      whyChooseThemes: [
        {
          headerText: 'Targeted Remote Collection',
          mainText: 'No more shipping collection kits, dispatching techs, or taking devices away from custodians. Reduce costs and time to discovery by leveraging PME\'s SaaS-based platform to perform user-led targeted remote collection. Custodians are guided through the process of collecting data from the relevant sources while preserving the privacy of out-of-scope data.',
          img: targetedRemoteCollection,
        },
        {
          headerText: 'Regional Data Storage',
          mainText: 'Maintain compliance and privacy with per-case data localization. Store your case data in multiple geographic regions while managing and accessing it all through a single site. Currently supporting data storage locations in the US, EU, and Asia.',
          img: regionalDataStorage,
        },
        {
          headerText: 'Web-based Review Platform',
          mainText: 'Your team can review case data from anywhere using only a web browser- highlight, comment, redact, tag, and export data in several convenient formats. View pictures, video, and documents, and listen to embedded audio, in context with transcriptions and translations. Leverage powerful search tools to surface relevant data while preserving its context.',
          img: webBasedReviewPlatform,
        },
        {
          headerText: 'Data Security & Privacy',
          mainText: 'The security and privacy of your data is our paramount concern. Custodian data is isolated on a per-case basis, encrypted in transit and at rest, and access is controlled by you through our robust access management controls.',
          img: dataSecurity,
        },
        {
          headerText: 'Data Sources & Devices',
          mainText: 'PME supports both iOS and Android based mobile devices and allows for collection from a growing list of data sources including Call Logs, Contacts, SMS, iMessage, WhatsApp, WeChat, Line, and Viber.',
          img: dataSources,
        },
        {
          headerText: 'Built-in Support Tools',
          mainText: 'We make supporting your data custodians easier by allowing you to see what they see while performing a collection, right from our site. Guide your custodians through real-time application visibility and validate the collection process by rewinding their session and visually playing back their steps.',
          img: builtInSupport,
        },
      ],
      reviewThemes: [
        {
          headerText: 'Secure and Scalable',
          mainText: 'PME combines a fully automated remote data collection tool with a powerful and intuitive review platform designed to gather and analyze valuable intelligence from mobile devices without the cost and complexity of legacy collection methods.',
          img: secureScalable,
        },
        {
          headerText: 'Web-Based Platform',
          mainText: 'Keep track of all your cases, review managers, and devices from a single dashboard with at-a-glance visualization of key metrics and insightful reporting to ensure you never lose tracks of assets or costs.',
          img: webBasedPlatf,
        },
        {
          headerText: 'Powerful Search Tools',
          mainText: 'Use the query builder to search across any combination of applications, time range, and users, with the ability to save searches, highlight and comment on results, and share with relevant parties.',
          img: searchTools,
        },
        {
          headerText: 'Intuitive Data Review',
          mainText: 'Gain deeper insights into custodian data with document OCR, audio and video transcription, and text extraction from images.',
          img: dataReview,
        },
        {
          headerText: 'Third-party Integration',
          mainText: 'PME Review can be integrated into third-party review platforms and data sources via API, or simply extract you data in an easily consumable format.',
          img: thirdPI,
        },
      ]
    };
  },
  validations: {
    formData: {
      firstName: {
        required,
        minLength: minLength(2)
      },
      lastName: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    activeReviewTheme() {
      return this.reviewThemes[this.activeReviewIndex];
    },
  },
  watch: {
    '$route.path'(val) {
      if (val.includes('press')) {
        this.isPressPageOpen = true;
      } else {
        this.isPressPageOpen = false;
      }
    }
  },
  mixins: [login, debounce, errorHandler],
  created() {
    this.$load(async () => {
      let response = (await this.$api.socialLinks.getSocialLinks());
      this.googlePlay = response.data.body.googlePlay;
      this.appleStore = response.data.body.appleStore;
    });
  },
  mounted() {
    this.beforeEnterLoader(
      this.$refs.preloader,
      this.$refs.mainOverlay
    );

    if (this.$route.path.includes('press')) {
      this.isPressPageOpen = true;
    }
  },
  methods: {
    hasPermission,
    async handleScrollTo(sectionName) {
      if (!sectionName.toLowerCase().includes('press') && this.isPressPageOpen) {
        this.isPressPageOpen = false;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        this.debounce(async () => {
          await this.$router.push('/');
          await this.performScroll(sectionName);
        });
      } else {
        this.performScroll(sectionName);
      }
    },
    performScroll(sectionName) {
      if (sectionName.toLowerCase().includes('features')) {
        this.scrollToBenefits();
      } else if (sectionName.toLowerCase().includes('platform')) {
        const target = this.$refs.review;
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      } else if (sectionName.toLowerCase().includes('contact')) {
        this.scrollToContactForm();
      } else if (sectionName.toLowerCase().includes('press')) {
        this.isPressPageOpen = true;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        this.debounce(() => this.$router.push({name: 'PressRelease'}), 500);
      }
    },
    beforeEnterLoader(el, el2) {
      Velocity(
        el,
        {
          opacity: 1,
        },
        {
          duration: 400, easing: 'easeOutCubic', complete: function () {
            Velocity(
              el2,
              {translateY: '-100%'},
              {
                duration: 1000, easing: [0.7, 0, 0.3, 1], complete: function () {
                }
              }
            );
          }
        }
      );
    },
    onReviewThemeClick(index) {
      this.transitionName = index > this.activeReviewIndex ? 'slide-left' : 'slide-right';
      this.activeReviewIndex = index;
    },
    scrollToContactForm() {
      const target = this.$refs.contactSales;
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    },
    scrollToBenefits() {
      const target = this.$refs.benefits;
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$load(async () => {
          await this.$api.publicPage.sendContactSalesMail({
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            message: this.formData.message,
          }).then(() => {
            this.openDialogFormSuccess();
            this.formData.firstName = '';
            this.formData.lastName = '';
            this.formData.email = '';
            this.formData.message = '';
            this.$nextTick(() => {
              this.$v.$reset();
            });
          });
        }, (error) => {
          this.handleResponseError(error);
        });
      }
    },
    openDialogFormSuccess() {
      this.$refs.commonDialogFormSuccess.openPopups();
    },
    openCalendly() {
      if (window.Calendly) {
        window.Calendly.initPopupWidget({
          url: 'https://calendly.com/pmediscovery/pme-intro-demo'
        });
      }
    },
  }
};
</script>

<style scoped lang="scss">

* {
  box-sizing: border-box;
}

.container-small {
  max-width: 100%;
}

.hero-section {
  background: url("../assets/img/home/home-banner.png") no-repeat 90% 0 / 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 100px;
}

.hero-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
  padding: 100px 0 0 100px;
  gap: 20px;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 62px;
  color: var(--white-color);
  margin: 0;
}

.hero-descr {
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  color: var(--white-color);
  margin: 0;
}

.hero-btn-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-btn {
  width: 174px;
  height: 40px;
  padding: 8px 30px;
  border-radius: 20px;
  border: 1px solid #082655;
  background: var(--white-color);
  color: var(--accent-color);
  cursor: pointer;
  transition: all .5s;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.hero-btn:hover {
  background: transparent;
  color: var(--white-color);
  border: 1px solid var(--white-color);
}

.title {
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  color: var(--secondary-black-color);
  margin-top: 0;
  margin-bottom: 30px;
}

.descr {
  display: block;
  max-width: 685px;
  width: 100%;
  font-size: 22px;
  font-weight: 400;
  line-height: 30.8px;
  text-align: center;
  color: var(--secondary-text-color);
  margin: 0 auto;
  margin-bottom: 60px;
}

.main-overlay {
  width: 100vw;
  height: 100vh;
  background-color: var(--white-color);
  position: fixed;
  z-index: 999;
}

.home {
  position: relative;
  background-color: var(--white-color);
}

.preloader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* how works section */
.section-how-work {
  padding-top: 90px;

  .container-small {
    position: relative;
    display: flex;
    flex-direction: column;

    .explore {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 15px;
      left: 50%;
      transform: translate(-50%, -180%);
      max-width: 170px;
      width: 100%;
      height: 70px;
      cursor: pointer;

      p {
        display: block;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        line-height: 19.36px;
        text-align: center;
        color: var(--white-color);
        margin: 0;
      }
    }
  }
}

/* benefit section */
.section-benefit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(325.82deg, #F2F7FF 0%, #FAFAFA 100%);
}

.section-benefit .container-small {
  max-width: 1450px;
  width: 100%;
}

.section-benefit .container-small .title {
  font-size: 36px;
  font-weight: 500;
  line-height: 39.6px;
  text-align: center;
  color: var(--secondary-black-color);
  margin: 90px 0 40px;
}

.benefit-img-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.benefit-item-container {
  color: var(--white-color);
  font-size: 20px;
  width: 450px;
  height: 390px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  transition: all 0.5s ease;
}

.benefit-item-container svg path {
  fill: var(--accent-color);
}

.benefit-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: var(--white-color);
  margin: 24px 32px;
}

.benefit-logo {
  width: 60px;
  height: 60px;
  margin: 0 0 16px;
}

.benefit-item-title {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  text-align: center;
  color: var(--secondary-black-color);
  margin: 0 0 16px;
}

.benefit-item-container:hover {
  background-color: var(--accent-color);
  box-shadow: 0px 25px 30px rgba(15, 199, 210, 0.21);
  border-radius: 10px;
  cursor: default;
}

.benefit-item-container:hover .benefit-item-text {
  color: var(--white-color);
}

.benefit-item-container:hover .benefit-item-title {
  font-size: 26px;
  font-weight: 700;
  text-align: center;
  color: var(--white-color);
}

.benefit-item-container:hover svg path {
  fill: var(--white-color);
}

.benefit-item-text {
  margin: 0 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: center;
  color: var(--secondary-text-color);
}

/*  end benefit section */

/* review section */

.section-review {
  padding-top: 100px;
}

.section-review .container-small {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section-review .container-small .title {
  font-size: 36px;
  font-weight: 500;
  line-height: 57px;
  text-align: left;
  color: var(--secondary-black-color);
  margin-bottom: 65px;
}

.section-review .container-small .themes-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  max-width: 1240px;
  width: 100%;
  min-height: 660px;
  height: 100%;

  .themes-menu {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    border-bottom: 3px solid var(--case-btn-border-color);
    margin: 0 130px;

    .menu-item {
      font-size: 16px;
      font-weight: 500;
      line-height: 40px;
      text-align: center;
      color: var(--secondary-text-color);
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        color: var(--accent-color);
        box-shadow: 0 3px var(--accent-color);
      }

      .active {
        color: var(--accent-color);
        box-shadow: 0 3px var(--accent-color);
      }
    }
  }

  .review-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    position: relative;
    width: 100%;

    .theme-img-wrapper {
      min-height: 385px;
      height: 100%;
    }

    .theme-desc-wrapper {
      width: 100%;
      max-width: 515px;
      height: 105px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 25.6px;
      color: var(--secondary-text-color);
    }

    .contact-btn {
      width: 171px;
      height: 50px;
      padding: 8px;
      border-radius: 50px;
      font-size: 16px;
      font-weight: 500;
      line-height: 19.36px;
      text-align: center;
    }
  }
}

/*  end review section */

/*  collect section */

.section-collect {
  padding-top: 50px;
  padding-bottom: 130px;

  .container-small {
    display: flex;
    max-width: 1270px;
    width: 100%;

    .section-img-wrapper {
      max-width: 610px;
      width: 100%;
    }

    .section-desc-wrapper {
      display: flex;
      flex-direction: column;
      gap: 50px;
      max-width: 635px;
      width: 100%;
      padding: 110px 0 110px 100px;

      .title {
        font-size: 36px;
        font-weight: 500;
        line-height: 39.6px;
        text-align: left;
        color: var(--secondary-black-color);
        margin: 0;
      }

      .divider {
        padding-top: 25px;
        border-top: 1px solid var(--case-btn-border-color);
      }

      .text-wrapper {
        display: flex;
        gap: 15px;

        span {
          display: block;
          max-width: 500px;
          width: 100%;
          font-size: 16px;
          font-weight: 400;
          line-height: 25.6px;
          text-align: left;
          color: var(--secondary-text-color);
        }
      }
    }
  }
}

/*  end collect section */

/*  demo section */

.section-demo {
  width: 100%;
  height: 835px;
  background: url("../assets/img/home/blue-bg.png") 0 0/100% auto no-repeat;
  margin-bottom: 30px;
  overflow: hidden;

  .container-small {
    width: 100%;
    height: 100%;
    max-height: 835px;
    padding: 0;

    .content-wrapper {
      display: flex;
      height: 100%;
      max-height: 835px;

      .schedule-demo {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: 750px;
        width: 100%;
        height: 100%;
        max-height: 660px;
        background: url("../assets/img/home/bg-security.png") 0 30%/100% auto no-repeat;
        box-shadow: 0 0 90px 90px rgba(1, 10, 35, 0.35);
        padding: 3% 0 0 10%;

        .title {
          font-size: 48px;
          font-weight: 700;
          line-height: 62.4px;
          text-align: left;
          color: var(--white-color);
        }

        .text-wrapper {
          display: flex;
          gap: 15px;

          svg path {
            fill: var(--white-color);
          }

          span {
            display: block;
            max-width: 470px;
            width: 100%;
            font-size: 20px;
            font-weight: 400;
            line-height: 30px;
            text-align: left;
            color: var(--white-color);
          }
        }

        button {
          max-width: 190px;
          height: 50px;
          width: 100%;
          margin-top: 12px;
          border-radius: 50px;
        }
      }

      .contact-sales {
        padding: 1% 5%;

        .form-wrapper {
          display: flex;
          flex-direction: column;
          padding: 40px 32px;
          border-radius: 16px;
          background: linear-gradient(325.82deg, rgba(242, 247, 255, 0.15) 0%, rgba(250, 250, 250, 0.15) 100%);

          .title {
            font-size: 36px;
            font-weight: 500;
            line-height: 39.6px;
            text-align: left;
            color: var(--white-color);
            margin-bottom: 15px;
          }

          .text-wrapper {
            font-size: 20px;
            font-weight: 400;
            line-height: 30px;
            text-align: left;
            color: var(--white-color);
            margin-bottom: 32px;
          }

          button {
            max-width: 120px;
            width: 100%;
            height: 50px;
            border-radius: 50px;
            margin-top: 15px;
          }

          .hero-btn:hover {
            background: transparent;
            color: var(--white-color);
            border: 1px solid var(--white-color);
          }

          .form-group {
            display: flex;
            flex-direction: column;

            input {
              width: 100%;
              border: 1px solid var(--input-placeholder-value-color);
              background: transparent;
              border-radius: 25px;
              padding: 15px 20px;
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              line-height: 17px;
              color: var(--white-color);
            }

            .support-textarea {
              width: 100%;
              resize: none;
              min-height: 165px;
              outline: none;
              border: 1px solid var(--input-placeholder-value-color);
              border-radius: 25px;
              padding: 23px 30px;
              font-size: 14px;
              font-weight: 500;
              background: transparent;
              color: var(--white-color);
            }

            .support-textarea::placeholder {
              color: var(--input-placeholder-value-color);
            }

            .error {
              font-style: normal;
              font-weight: 500;
              font-size: 10px;
              line-height: 12px;
              color: var(--alert-color);
              margin: 10px 0 0 20px;
            }
          }
        }
      }
    }
  }
}

.slide-enter-active, .slide-leave-active {
  transition: max-height 1s ease, opacity 1s ease;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-enter-to, .slide-leave {
  max-height: 1000px;
  opacity: 1;
}

.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: transform 0.2s ease;
}

.slide-left-enter, .slide-right-leave-to {
  transform: translateX(100%);
}

.slide-left-leave-to, .slide-right-enter {
  transform: translateX(-100%);
}
</style>
